// extracted by mini-css-extract-plugin
module.exports = {"commercial":"HomeWidgetCommercial_commercial__A7BKz","commercialIcon":"HomeWidgetCommercial_commercialIcon__LwRop","pulse":"HomeWidgetCommercial_pulse__v0gux"};